var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogpostRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6272 18.6272 24 12 24C5.37278 24 0 18.6272 0 12C0 5.37278 5.37278 0 12 0C18.6272 0 24 5.37278 24 12Z",
    fill: "#F58220"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23857_53945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4583 4H5.54167C4.69023 4 4 4.69023 4 5.54167V18.4583C4 19.3098 4.69023 20 5.54167 20H18.4583C19.3098 20 20 19.3098 20 18.4583V5.54167C20 4.69023 19.3098 4 18.4583 4Z",
    fill: "#F58220"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 14.666H10.0003C9.62533 14.666 9.29199 14.3743 9.29199 13.9993C9.29199 13.6243 9.62533 13.3327 10.0003 13.3327H14.0003C14.3753 13.3327 14.667 13.6243 14.667 13.9993C14.667 14.3743 14.3753 14.666 14.0003 14.666ZM10.0003 9.29102H11.9587C12.3337 9.29102 12.6253 9.58268 12.6253 9.95768C12.6253 10.3327 12.3337 10.6243 11.9587 10.6243H10.0003C9.62533 10.6243 9.29199 10.3327 9.29199 9.95768C9.29199 9.58268 9.62533 9.29102 10.0003 9.29102ZM17.542 11.041L17.4587 10.8327L17.292 10.7077C17.0837 10.5827 16.042 10.7493 15.7503 10.4993C15.5837 10.291 15.542 9.95768 15.4587 9.54102C15.3753 8.66602 15.292 8.62435 15.167 8.33268C14.667 7.29102 13.3337 6.49935 12.417 6.41602H9.95866C8.00033 6.41602 6.41699 7.99935 6.41699 9.91602V14.041C6.41699 15.9993 8.00033 17.5827 9.95866 17.5827H14.0003C15.9587 17.5827 17.542 15.9993 17.542 14.041L17.5837 11.7077V11.2077L17.542 11.041Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23857_53945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogpostRounded);
export default __webpack_public_path__ + "static/media/blogpost-rounded.a6fc7bf118b91a1ed847f10301c72a41.svg";
export { ForwardRef as ReactComponent };